<template>
  <div
    class="countdown-btn"
    :style="active && !countdown ? activeStyle : inactiveStyle"
    @click="handleClick"
  >
    <!-- :class="active ? 'active' : 'inactive'" -->
    <span v-show="!countdown">{{ $t(countdownText || text)}}</span>
    <span v-show="countdown">{{ $t(count) }}s</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '获取验证码'
    },
    active: {
      type: Boolean,
      default: false
    },
    // 倒计时总数量
    totalCount: {
      type: Number,
      default: 5
    },
    color: {
      type: String,
      default: '#4A6AFF'
    },
    // 默认颜色
    inactiveStyle: {
      type: String,
      default: 'border: 1px solid #AEB5C2; color: #AEB5C2;'
    }
  },
  data () {
    return {
      countdownText: '',
      // 是否开始计时
      countdown: false,
      // 倒计时时间
      count: 0,
      // 定时器
      timer: null
    }
  },
  computed: {
    activeStyle () {
      const { color } = this
      return `border: 1px solid ${color}; color: ${color};`
    }
  },
  methods: {
    handleClick () {
      const { active, countdown } = this
      // 如果定时器不是活跃状态 禁止点击
      if (!active) return
      // 判断定时器是否已经开启
      if (countdown) return
      this.$emit('click')
    },
    startCountDown () {
      this.countdown = true
      const { totalCount } = this
      this.handleStartCount(totalCount)
    },
    stopCountDown () {
      this.timer && clearInterval(this.timer)
      this.countdown = false
      this.count = 0
    },
    handleStartCount (totalCount) {
      this.count = totalCount
      this.timer = setInterval(() => {
        if (this.count <= 0) {
          clearInterval(this.timer)
          this.countdown = false
          this.countdownText = '重新获取'
          return
        }
        this.count -= 1
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
.countdown-btn {
  display: inline-block;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 400;
  > span {
    user-select: none;
  }
}
</style>
